import { ApiService, GenericError} from './api-main'

const CustomerLoyaltyService = {
    getCustomerCardDetails: async function() {
        const params = {
        }
        const url = 'main/customerloyalty/search'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, '7002')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getActiveCardStampDetails: async function(cardId) {
        const params = {
            cardId : cardId
        }
        const url = 'main/customerloyalty/activecardstampshistory'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, 'SH2015')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getInviteLink: async function() {
        const url = 'main/referralcode'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            console.log(response)
            return ApiService.validateResponse(response, 'WN00430')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getDiscountDetail: async function(cmpId) {
        const url = 'main/discountCampaign'
        try {
            const params = {
                campaignId           : cmpId,
                rbId                 : 0,
                destinationCountryId : 0,
            }
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            console.log(response)

            return ApiService.validateResponse(response, '4319');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },

}

export default CustomerLoyaltyService